import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home' // 首页
import personal from '@/view/personal' // 个人中心
import personalInformation from '@/view/personalInformation' // 资料设置
import collection from '@/view/collection' // 我的收藏
import history from '@/view/history' // 借阅历史
import again from '@/view/again' // 再借信息
import reserve from '@/view/reserve' // 预约结果
import cartoon from '@/view/cartoon' // 一卡通
import integral from '@/view/integral' // 积分记录
import guide from '@/view/guide' // 读者指南
import resource from '@/view/resource' // 资源
import project from '@/view/project' // 专题
import projectList from '@/view/projectList' // 专题列表
import articleDetails from '@/view/articleDetails' // 专题文章详情
import messageBoard from '@/view/messageBoard' // 留言板
import openTime from '@/view/openTime' // 开馆时间
import information from '@/view/information' // 资讯
import notice from '@/view/notice' // 最新公告
import news from '@/view/news' // 国图新闻
import solicitation from '@/view/solicitation' // 征集启事
import newsDetail from '@/view/newsDetail' // 国图新闻详情
import bookRecommend from '@/view/bookRecommend' // 书刊推荐
import trailer from '@/view/trailer' // 国图预告
import lecture from '@/view/lecture' // 讲座预告
import teacherDetail from '@/view/teacherDetail' // 讲师简介
import guideDirectory from '@/view/guideDirectory' // 指南目录
import exhibitionDetail from '@/view/exhibitionDetail' // 展览详情
import cultural from '@/view/cultural' // 文创
import application from '@/view/application' // 应用荟萃
import applicationDetails from '@/view/applicationDetails' // 应用荟萃详情
import poetryRead from '@/view/poetryRead' // 文津经典诵读
import search from '@/view/search' // 搜索页面
import statistical from '@/view/statistical' // 今日数据
import opacView from '@/view/opacView' // 查看单册信息
import updatePassword from '@/view/updatePassword' // 修改密码
import culturalDetail from '@/view/culturalDetail' // 修改密码
import articleChildDetails from '@/view/articleChildDetails' // 专题详情子页面
import guideLevel from '@/view/guideLevel' // 读者指南三级目录
import copyright from '@/view/copyright' // 读者指南三级目录
import museumCollection from '@/view/museumCollection' // 馆藏
import question from '@/view/question' // 问卷
import questionList from '@/view/questionList' // 问卷列表
import parsing from '@/view/parsing' // 题目解析
import read from '@/view/read' // 文津经典诵读

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: { title: '首页'}
    },
    {
      path: '/personal',
      name: 'personal',
      component: personal,
      meta: { title: '个人中心'}
    },
    {
      path: '/personalInformation',
      name: 'personalInformation',
      component: personalInformation,
      meta: { title: '个人信息', parentModule:'个人中心'}
    },
    {
      path: '/collection',
      name: 'collection',
      component: collection,
      meta: { title: '我的收藏', parentModule:'个人中心'}
    },
    {
      path: '/history',
      name: 'history',
      component: history,
      meta: { title: '借阅历史', parentModule:'个人中心'}
    },
    {
      path: '/again',
      name: 'again',
      component: again,
      meta: { title: '在借信息', parentModule:'个人中心'}
    },
    {
      path: '/reserve',
      name: 'reserve',
      component: reserve,
      meta: { title: '预约结果', parentModule:'个人中心'}
    },
    {
      path: '/cartoon',
      name: 'cartoon',
      component: cartoon,
      meta: { title: '一卡通', parentModule:'个人中心'}
    },
    {
      path: '/integral',
      name: 'integral',
      component: integral,
      meta: { title: '积分记录', parentModule:'个人中心'}
    },
    {
      path: '/guide',
      name: 'guide',
      component: guide,
      meta: { title: '读者指南'}
    },
    {
      path: '/resource',
      name: 'resource',
      component: resource,
      meta: { title: '数字资源'}
    },
    {
      path: '/project',
      name: 'project',
      component: project,
      meta: { title: '专题展览'}
    },
    {
      path: '/articleDetails/:id',
      name: 'articleDetails',
      component: articleDetails,
      meta: { title: '专题文章详情', parentModule:'专题展览'}
    },
    {
      path: '/messageBoard',
      name: 'messageBoard',
      component: messageBoard,
      meta: { title: '联系我们'}
    },
    {
      path: '/openTime',
      name: 'openTime',
      component: openTime,
      meta: { title: '读者指南详情', parentModule:'读者指南'}
    },
    {
      path: '/information',
      name: 'information',
      component: information,
      meta: { title: '资讯'}
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice,
      meta: { title: '最新公告', parentModule:'资讯', keepAlive: true}
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: { title: '国图新闻', parentModule:'资讯', keepAlive: true}
    },
    {
      path: '/solicitation',
      name: 'solicitation',
      component: solicitation,
      meta: { title: '征集启示', parentModule:'资讯', keepAlive: true}
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail,
      meta: { title: '资讯详情', parentModule:'资讯'}
    },
    {
      path: '/bookRecommend',
      name: 'bookRecommend',
      component: bookRecommend,
      meta: { title: '书刊推介'}
    },
    {
      path: '/trailer',
      name: 'trailer',
      component: trailer,
      meta: { title: '国图预告'}
    },
    {
      path: '/lecture',
      name: 'lecture',
      component: lecture,
      meta: { title: '预告列表', parentModule:'国图预告'}
    },
    {
      path: '/teacherDetail',
      name: 'teacherDetail',
      component: teacherDetail,
      meta: { title: '讲师简介', parentModule:'国图预告'}
    },
    {
      path: '/guideDirectory',
      name: 'guideDirectory',
      component: guideDirectory,
      meta: { title: '指南目录', parentModule:'读者指南'}
    },
    {
      path: '/exhibitionDetail',
      name: 'exhibitionDetail',
      component: exhibitionDetail,
      meta: { title: '预告详情', parentModule:'国图预告'}
    },
    {
      path: '/projectList',
      name: 'projectList',
      component: projectList,
      meta: { title: '专题列表', parentModule: '专题展览', keepAlive: true}
    },
    {
      path: '/cultural',
      name: 'cultural',
      component: cultural,
      meta: { title: '文创展示', keepAlive: true}
    },
    {
      path: '/application',
      name: 'application',
      component: application,
      meta: { title: '关注我们列表', parentModule: '关注我们'}
    },
    {
      path: '/applicationDetails',
      name: 'applicationDetails',
      component: applicationDetails,
      meta: { title: '关注我们详情', parentModule: '关注我们'}
    },
    {
      path: '/poetryRead',
      name: 'poetryRead',
      component: poetryRead,
      meta: { title: '文津经典诵读'}
    },
    {
      path: '/read',
      name: 'read',
      component: read,
      meta: { title: '文津经典诵读'}
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        title: '检索',
        // 需要缓存
        keepAlive: true
      }
    },
    {
      path: '/statistical',
      name: 'statistical',
      component: statistical,
      meta: { title: '动态数据'}
    },
    {
      path: '/opacView',
      name: 'opacView',
      component: opacView,
      meta: { title: 'opac检索', parentModule: '检索'}
    },
    {
      path: '/updatePassword',
      name: 'updatePassword',
      component: updatePassword,
      meta: { title: '修改密码', parentModule: '个人中心'}
    },
    {
      path: '/culturalDetail',
      name: 'culturalDetail',
      component: culturalDetail,
      meta: { title: '文创详情', parentModule: '国图文创'}
    },
    {
      path: '/articleChildDetails',
      name: 'articleChildDetails',
      component: articleChildDetails,
      meta: { title: '专题详情', parentModule: '专题展览'}
    },
    {
      path: '/guideLevel',
      name: 'guideLevel',
      component: guideLevel,
      meta: { title: '指南目录', parentModule: '读者指南'}
    },
    {
      path: '/copyright',
      name: 'copyright',
      component: copyright,
      meta: { title: '版权声明', parentModule: '版权声明'}
    },
    {
      path: '/museumCollection',
      name: 'museumCollection',
      component: museumCollection,
      meta: { title: '馆藏目录',keepAlive: true}
    },
    {
      path: '/question',
      name: 'question',
      component: question,
      meta: { title: '问卷调查'}
    },
    {
      path: '/questionList',
      name: 'questionList',
      component: questionList,
      meta: { title: '问卷调查列表'}
    },
    {
      path: '/parsing',
      name: 'parsing',
      component: parsing,
      meta: { title: '题目解析'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js